function asideChangePosition() {
  const navPlaceContent = document.querySelector('[data-nav-placement]')
  const pageContent = document.querySelector('[data-page-content]')
  const asideNav = document.querySelector('[data-aside-nav]')
  const asideNavList = document.querySelector('[data-aside-nav-list]')
  const sectionsManager = pageContent.querySelectorAll(
    '[data-layout-manager-section]',
  )
  const sectionsDefault = pageContent.querySelectorAll('section')
  const section = sectionsManager.length ? sectionsManager : sectionsDefault

  if (pageContent && asideNavList) {
    //
    let dataNav = []

    section.forEach((item, index) => {
      if (item.querySelector('h2')) {
        const sectionID = `section-${index + 1}`
        item.id = sectionID
        dataNav.push({
          title: item.querySelector('h2').textContent,
          href: sectionID,
        })
      }
    })

    dataNav.length
      ? asideNav.classList.remove('hidden')
      : asideNav.classList.add('hidden')

    //
    asideNavList.innerHTML = dataNav
      .map(
        ({ title, href }) =>
          `<li><a href="#${href}" class="link">${title}</a></li>`,
      )
      .join('')
    //

    if (navPlaceContent && window.innerWidth <= 1365) {
      let asideNav = document.querySelector('[data-aside-nav]')
      navPlaceContent.prepend(asideNav)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  asideChangePosition()
  document.querySelector('[data-layout-manager]') &&
    document
      .querySelector('[data-layout-manager]')
      .addEventListener('onComplete', asideChangePosition)
})
